"use strict";
const APPKIT_SCROLL_LOCK_SELECTOR = 'style[data-w3m="scroll-lock"]';
const APPKIT_OPEN_MODAL_SELECTOR = "w3m-modal.open";
export function removeStaleAppKitScrollLock(doc) {
  if (doc.querySelector(APPKIT_OPEN_MODAL_SELECTOR)) {
    return 0;
  }
  const stale = Array.from(doc.head.querySelectorAll(APPKIT_SCROLL_LOCK_SELECTOR));
  stale.forEach((tag) => tag.remove());
  return stale.length;
}
export function scheduleStaleAppKitScrollLockCleanup(doc = document) {
  ;
  [0, 500].forEach((delay) => setTimeout(() => removeStaleAppKitScrollLock(doc), delay));
}
const shortCircuited = /* @__PURE__ */ new WeakSet();
function requestedChainId(params) {
  const first = Array.isArray(params) ? params[0] : void 0;
  const raw = first && typeof first === "object" && "chainId" in first ? first.chainId : void 0;
  if (typeof raw === "number") {
    return raw;
  }
  if (typeof raw === "string") {
    const parsed = parseInt(raw, 16);
    return Number.isFinite(parsed) ? parsed : void 0;
  }
  return void 0;
}
export function shortCircuitSameChainSwitch(provider) {
  if (shortCircuited.has(provider)) {
    return provider;
  }
  const original = provider.request.bind(provider);
  provider.request = async (args) => {
    if (args.method === "wallet_switchEthereumChain") {
      const target = requestedChainId(args.params);
      if (target !== void 0 && target === provider.chainId) {
        return null;
      }
    }
    return original(args);
  };
  shortCircuited.add(provider);
  return provider;
}
